import React from 'react';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage, FormattedDate} from 'react-intl';

import * as BetStatuses from 'constants/BetStatus';

import {removeHistoryBet as removeHistoryBetAction} from 'actions/creators/HistoryBet';

const messages = defineMessages({
    notAccepted: {
        id: 'bet_status.not_accepted',
        defaultMessage: 'Не принята'
    },
    newBet: {
        id: 'bet_title.new_bet',
        defaultMessage: 'Новая ставка'
    }
});

class BetTitle extends React.Component {
    static propTypes = {
        id: React.PropTypes.string.isRequired,
        bet: React.PropTypes.object.isRequired,
        removeHistoryBetAction: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this._onRemoveClick = this._onRemoveClick.bind(this);
    }

    _onRemoveClick(e) {
        e.preventDefault();
        this.props.removeHistoryBetAction(this.props.id);
    }

    render() {
        const bet = this.props.bet;

        if (!bet) {
            return false;
        }

        const betStatus = bet.get('betStatus');
        const stakeId = bet.get('stakeId');
        const stakeTime = bet.get('stakeTime');

        let stakeIdStr;
        let stakeTimeSpan;
        if (stakeId) {
            stakeIdStr = '#' + stakeId;
        }
        if (stakeTime) {
            stakeTimeSpan = (<FormattedDate value={stakeTime}
                                            day="numeric"
                                            month="numeric"
                                            hour="numeric"
                                            minute="numeric"
                                            second="numeric"/>);
        }

        switch (betStatus) {
            case BetStatuses.INIT:
            case BetStatuses.IN_DELAY:
            case BetStatuses.CONFIRM_AWAIT:
            case BetStatuses.BET_PAY_REQUEST:
                return (<div className="title title-white cf">
                            <span>
                                <FormattedMessage {...messages.newBet} />
                            </span>
                            <a href="#" className="close" onClick={this._onRemoveClick}>{'\u00A0'}</a>
                        </div>);

            case BetStatuses.REJECTED:
                return (<div className="title cf">
                            <span className="not-accepted">
                                <FormattedMessage {...messages.notAccepted} />
                            </span>
                            <a href="#" className="close" onClick={this._onRemoveClick}>{'\u00A0'}</a>
                        </div>);

            case BetStatuses.CALCULATED:
            case BetStatuses.CASHOUT:
            case BetStatuses.CONFIRMED:
                return (<div className="title cf">
                            <span className="bet-id pull-left">{stakeIdStr}</span>
                            <span className="bet-date pull-right">{stakeTimeSpan}</span>
                            <a href="#" className="close" onClick={this._onRemoveClick}>{'\u00A0'}</a>
                        </div>);

            default:
                return (<div className="title cf">
                            <a href="#" className="close" onClick={this._onRemoveClick}>{'\u00A0'}</a>
                        </div>);
        }
    }
}

function select(state, props) {
    const id = props.id;
    const bet = state.application.getIn(['betHistory', id]);
    const languageId = state.application.get('languageId');

    return {
        id,
        bet,
        languageId
    };
}

export default connect(select, {
    removeHistoryBetAction
})(BetTitle);



// WEBPACK FOOTER //
// ./js/sport-betting/components/bet-panel-control/bet-history/BetTitle.jsx